import { BaseModel } from './base.model'

export class ParsedUser extends BaseModel<ParsedUser> {
  static DEFAULT_ATTRIBUTES = {}

  _destroy: boolean
  firstname: string
  middlename: string
  lastname: string
  license: string
  mark: number
  cityId: number
  course: string
  id: number
  comment: string
  source: string
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/parsed-user.model.ts